import { type SourcingScenarioDTO } from '@luminovo/api-contracts';

/** Created per demand group by awarding; users never edit, compare or source one as a scenario. */
export function isAwardScenario(scenario: SourcingScenarioDTO): boolean {
    return scenario.sourcing_scenario_type === 'AwardScenario';
}

/** Render sites only: filtering earlier silently empties the Awarding screen, which reads the same arrays. */
export function excludeAwardScenarios(scenarios: SourcingScenarioDTO[]): SourcingScenarioDTO[] {
    return scenarios.filter((scenario) => !isAwardScenario(scenario));
}
